import type { Item } from './useMessages';

const getEmailClassName = (message: Item) => {
  switch (message.author_type) {
    case 'User':
      return 'bg-[#F59E0B26] border-l-[#F59E0B] text-[#F59E0B]';
    case 'Orchestrator':
      return 'bg-[#F9731619] border-l-[#F97316] text-[#F97316]';
    case 'Assistant':
      return 'bg-[#3B82F619] border-l-[#3B82F6] text-[#3B82F6]';
    default:
      return '';
  }
};
const getPhoneClassName = (message: Item) => {
  switch (message.author_type) {
    case 'User':
      return 'bg-[#8B5CF626] border-l-[#8b5cf6] text-[#8b5cf6]';
    case 'Orchestrator':
      return 'bg-[#8B5CF619] border-l-[#8b5cf6] text-[#8b5cf6]';
    case 'Assistant':
      return 'bg-[#EC489919] border-l-[#ec4899] text-[#ec4899]';
    default:
      return '';
  }
};
const getSMSClassName = (message: Item) => {
  switch (message.author_type) {
    case 'User':
      return 'bg-cyan-300 border-l-cyan-300';
    case 'Orchestrator':
      return 'bg-[#10B98119] border-l-[#10b981] text-[#10b981]';
    case 'Assistant':
      return 'bg-[#06B6D419] border-l-[#06b6d4] text-[#06b6d4]';
    default:
      return '';
  }
};
const getServerClassName = (message: Item) => {
  switch (message.author_type) {
    case 'HUMAN_REPRESENTATIVE':
      return 'bg-[#EA580C1A] border-l-[#ea580c] text-[#ea580c]';
    default:
      return '';
  }
};

export const getMessageClassName = (message: Item): string => {
  switch (message.conversation_channel) {
    case 'Email':
      return getEmailClassName(message);
    case 'Phone':
      return getPhoneClassName(message);
    case 'SMS':
      return getSMSClassName(message);
    case 'Server':
      return getServerClassName(message);
    default:
      return '';
  }
};
